import { WrappedWithBackButton } from '../common/wrapped-with-back-button';
import {
    Edit,
    SelectArrayInput,
    SimpleForm,
    useNotify,
    useRecordContext,
    useRedirect,
} from 'react-admin';
import dataProvider from '../dataProvider';

export const WebUserEdit = () => {
    return (
        <WrappedWithBackButton>
            <Edit title={'Felhasználó szerkesztése'}>
                <WebUserForm />
            </Edit>
        </WrappedWithBackButton>
    );
};

const WebUserForm = () => {
    const record = useRecordContext();
    const notify = useNotify();
    const redirect = useRedirect();

    const codes = (record?.partnerIds ?? []).map((value: string) => ({
        id: value,
        name: value,
    }));

    return (
        <SimpleForm
            onSubmit={async (values) => {
                const requestBody = {
                    partnerIds: values.partnerIds,
                };
                await dataProvider
                    .update('web-user', {
                        id: record.id,
                        data: requestBody,
                    })
                    .then((res) => {
                        if (res.data) {
                            notify(`Sikeres módosítás`, { type: 'success' });
                            redirect('show', 'web-user', record.id);
                        } else {
                            notify(`Hiba történt`, { type: 'error' });
                        }
                    });
            }}
        >
            {record?.partnerIds && (
                <SelectArrayInput
                    fullWidth
                    source="partnerIds"
                    label="Partner kódok"
                    choices={codes}
                    options={{ autoWidth: false }}
                />
            )}
        </SimpleForm>
    );
};
